import {
  serviceHistory,
} from "constants/customer";

const initialState = {
  serviceHistory: {},
};

const customer = (state = initialState, action) => {
  switch (action.type) {
    case serviceHistory:
      return { ...state, serviceHistory: action.payload };
    default:
      return state;
  }
};

export default customer;
